var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rectangle.bounds != null)?_c('LRectangle',{attrs:{"bounds":_vm.rectangle.bounds,"l-style":_vm.rectangle.style}}):_vm._e(),(_vm.images)?_c('SlicedImageLayer',{attrs:{"bounds":_vm.bounds,"images":_vm.images}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }